import axiosInstance from './axiosConfig';

/**
 * 過去7日間のチャット履歴を取得
 * @returns チャット履歴の配列
 */
export const getRecentHistory = async () => {
  const response = await axiosInstance.get('/history/recent');
  return response.data.data;
};

/**
 * 過去8-30日間のチャット履歴を取得
 * @returns チャット履歴の配列
 */
export const getOlderHistory = async () => {
  const response = await axiosInstance.get('/history/older');
  return response.data.data;
};
